import { useLocation } from 'react-router-dom';
import { NavigationItem } from './useNavigation';
import { useAccess } from '../components/access/AccessProvider';

export function useNavigationState() {
  const location = useLocation();
  const { access } = useAccess();

  const isItemActive = (item: NavigationItem): boolean => {
    return (
      location.pathname === item.href ||
      (item.href !== '/' && location.pathname.startsWith(item.href + '/'))
    );
  };

  const isItemAccessible = (item: NavigationItem): boolean => {
    // Never display Files
    if (item.name === 'Files') {
      return false;
    }

    if (!access) return false;
    const permissionOk = !item.permission || access.permissions.has(item.permission);
    const featureOk = !item.feature || access.features.has(item.feature);
    return permissionOk && featureOk;
  };

  const isItemVisible = (item: NavigationItem): boolean => {
    // Never display Files
    if (item.name === 'Files') {
      return false;
    }

    if (!access) return false;
    if (item.limit_visibility) {
      // Only show if user has BOTH the required feature and permission (if set)
      const permissionOk = !item.permission || access.permissions.has(item.permission);
      const featureOk = !item.feature || access.features.has(item.feature);
      return permissionOk && featureOk;
    }
    // Show item if feature requirement is met (regardless of permission for pro upgrade)
    return !item.feature || access.features.has(item.feature);
  };

  return {
    isItemActive,
    isItemAccessible,
    isItemVisible,
  };
}
